import Entity from 'utilities/entity';

class People extends Entity {}

export default new People();
